var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[_c('img',{attrs:{"alt":"Logotipo Truework","src":require("@/assets/img/tw.png")}})])
}]

export { render, staticRenderFns }